import { Filter } from '~/evifields/src/types/Filter';
import { SearchQuery } from '~/features/advanced-search/types';
import { toSearchV3Filter } from '~/redux/api/methods/searchV3';
import { SearchFilter } from '~/types/DashboardV2';
import {
  BooleanQueryEntity,
  QueryOperatorEntity,
  SectionEntity,
} from '~/types/OpenSearch';

import {
  testIsBooleanTextSearch,
  testIsFilter,
  testIsOperator,
  testIsSection,
} from '../../search/utils/queryUtils';

export type SectionFilters = {
  type: 'section';
  values: QueryFilters[];
};

export type QueryFilters =
  | SectionFilters
  | QueryOperatorEntity
  | Filter
  | BooleanQueryEntity;

export const mapQuerytoSectionFiltersOperators = (
  query: SearchQuery,
  searchFilters: Record<string, SearchFilter>,
): QueryFilters[] => {
  return query.map((item) => {
    if (testIsSection(item)) {
      return {
        type: 'section',
        values: item.value.map((a) =>
          mapQuerySectionEntityItemToSectionFilterItem(a, searchFilters),
        ),
      };
    } else {
      return mapQuerySectionEntityItemToSectionFilterItem(item, searchFilters);
    }
  });
};

const mapQuerySectionEntityItemToSectionFilterItem = (
  item: SectionEntity['value'][number],
  searchFilters: Record<string, SearchFilter>,
): QueryFilters => {
  if (testIsOperator(item) || testIsBooleanTextSearch(item)) {
    return item;
  } else if (testIsFilter(item)) {
    return toSearchV3Filter(item, searchFilters);
  } else {
    return {
      type: 'section',
      values: mapQuerytoSectionFiltersOperators(item.value, searchFilters),
    };
  }
};
